// components/Integration/AppList.jsx
import React from "react";
import { Button, Card } from "react-bootstrap";
import whatsapppay from "../../../images/whatsapppay.jpg";
import Razorpay from "../../../images/Razorpay.jpg";
import Payu from "../../../images/PayU.jpg";
import Aspire from "../../../images/Aspire.jpg";
import Xendit from "../../../images/Xendit.jpg";
import Pabbly from "../../../images/Pabbly.jpg";

// catagories  :
// Payment provider
// CRM Platform
// Account Upgrades
// Connector Platforms
// Data storage
// e-Commerce Platform
// Ads Platform
// Marketing Automation
// Helpdesk Platform
// Billing Platform
// Product Review Platform
// Scheduling Automation Platform
// Accounting Software

const AppList = ({ type, category }) => {
  const apps = [
    {
      name: "WhatsApp Pay",
      type: "free",
      category: "Payment",
      description:
        "Create a frictionless payment experience on WhatsApp to improve conversions",
      button: "Connect",
      badge: "Free",
      image: whatsapppay,
    },
    {
      name: "Razorpay",
      type: "free",
      category: "Payment",
      description: "Send payment links automatically in a checkout botflow",
      button: "Connect to Interakt",
      badge: "Free",
      image: Razorpay,
    },
    {
      name: "PayU",
      type: "free",
      category: "Payment",
      description: "Auto-checkout with WhatsApp carts",
      button: "Connect to Interakt",
      badge: "Free",
      image: Payu,
    },
    {
      name: "Aspire",
      type: "paid",
      category: "Finance",
      description: "Auto-checkout experience for customers",
      button: "Connect to Interakt",
      badge: "Paid",
      image: Aspire,
    },
    {
      name: "Xendit",
      type: "paid",
      category: "Payment",
      description: "Auto-checkout experience on WhatsApp",
      button: "Connect to Interakt",
      badge: "Paid",
      image: Xendit,
    },
    {
      name: "Pabbly Connect",
      type: "free",
      category: "Automation",
      description: "Send WhatsApp notifications from any software",
      button: "View Details",
      badge: "Free",
      image: Pabbly,
    },
  ];

  const filteredApps = apps.filter((app) => {
    const typeMatch =
      type === "all" ||
      app.type === type ||
      (type === "my" && app.name.includes("Interakt"));
    const categoryMatch = category === "All" || app.category === category;
    return typeMatch && categoryMatch;
  });

  return (
    <div className="row mt-4">
      {filteredApps.map((app, idx) => (
        <div key={idx} className="col-md-6 col-lg-4 mb-4">
          <Card
            className="shadow-sm border-0 rounded-4"
            style={{ width: "400px", height: "250px" }}
          >
            <Card.Body className="d-flex flex-column">
              {/* Top Row */}
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-start gap-3">
                  <img src={app.image} alt="App Logo" width="40" height="40" />
                  <div>
                    <h6 className="mb-0">{app.name}</h6>
                    <p className="text-muted small">Payment Provider</p>
                    <p
                      className="text-muted mt-3 mb-2"
                      style={{ textAlign: "justify", fontSize: "0.75rem" }}
                    >
                      {app.description}
                    </p>
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm align-self-start mb-3"
                    >
                      <i class="bi bi-play-circle-fill me-1"></i> Watch Video
                    </button>
                  </div>
                </div>
                <span
                  className={`badge rounded-pill px-3 py-1 mt-1 ${
                    app.badge === "Free" ? "bg-success" : "bg-primary"
                  }`}
                >
                  {app.badge}
                </span>
              </div>
            </Card.Body>

            <div className="mt-auto">
              <Button
                variant="success"
                className="w-100 border-0 fw-semibold"
                style={{
                  borderRadius: "0 0 16px 16px",
                }}
              >
                {app.button}
              </Button>
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default AppList;
